import {Pipe, PipeTransform} from "@angular/core";
import {Minion} from "../_models/fleet";
import {User} from "../_models/user";
import {UtilitiesService} from "../../core/_services/utilities.service";

@Pipe({
    name: 'fullName'
})
export class FullNamePipe implements PipeTransform {

    transform(person: Minion | User): String {
        if (UtilitiesService.isEmpty(person)
            || !person.firstName
            || !person.lastName) {
            return '';
        }
        return `${person.firstName} ${person.lastName}`;
    } // transform()

} // AddPipe
